<div class="private-layout">
  <app-progress-spinner [hidden]="!(authLoading$ | async)"></app-progress-spinner>

  <app-private-header
    [user$]="user$"
    [newNotificationCount$]="newNotificationCount$"
    (changeNotificationVisibleEvent)="changeNotificationSidebarVisible($event)"
    (changeUserSidebarVisibleEvent)="changeUserSidebarVisible($event)"
    (logoutEvent)="logout()"
  >
  </app-private-header>

  <div
    class="private-layout__content"
    [class.private-layout__content--patient]="(user$ | async)?.isPatient"
    [class.private-layout__content--doctor]="(user$ | async)?.isDoctor"
    [class.private-layout__content--admin]="(user$ | async)?.role === 'admin' || (user$ | async)?.role === 'platform_admin'"
  >
    <!-- Patient-only persistent portal navigation (renders nothing for other roles). -->
    <app-patient-sidebar></app-patient-sidebar>

    <!-- Admin-only persistent navigation (renders nothing for other roles). -->
    <app-admin-sidebar></app-admin-sidebar>

    <!-- Doctor-only persistent clinician navigation (renders nothing for other roles). -->
    <app-doctor-sidebar></app-doctor-sidebar>

    <!-- Care Guide chat: self-gating — renders nothing unless the user is a
         patient AND on /office/portal/** or /office/acp/** (doctor/admin/proxy
         layouts untouched). -->
    <app-care-guide-chat></app-care-guide-chat>

    <div class="private-layout__main">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
    <ng-template #notificationSidebar></ng-template>

    <app-user-sidebar
      [loading$]="userLoading$"
      [userSidebarVisible$]="userSidebarVisible$"
      (logoutEvent)="logout()"
      (passwordChangeEvent)="passwordChange($event)"
      (changeUserSidebarVisibleEvent)="changeUserSidebarVisible($event)"
    >
    </app-user-sidebar>

  </div>
</div>

